import type { Permiso } from '@barbones/shared';
import { ShieldOff } from 'lucide-react';
import type { ComponentType } from 'react';
import { useSesion } from '@/api/sesion';
import { ModuleLayout } from '@/components/layout/ModuleLayout';
import { Tarjeta, Vacio } from '@/components/ui/data';

export function SinAcceso() {
  return (
    <ModuleLayout titulo="Sin acceso">
      <Tarjeta className="mt-6">
        <Vacio icono={<ShieldOff />} titulo="No tienes acceso a esta sección" descripcion="Si lo necesitas, pide al dueño que te asigne el permiso." />
      </Tarjeta>
    </ModuleLayout>
  );
}

/** Envuelve una página: se muestra solo si el usuario tiene alguno de los permisos (la API también lo valida). */
export function protegida(permisos: Permiso[], Pagina: ComponentType) {
  return function PaginaProtegida() {
    const { usuario } = useSesion();
    return usuario?.permisos.some((p) => permisos.includes(p)) ? <Pagina /> : <SinAcceso />;
  };
}
